<template>
  <modal
    v-slot="{ data }"
    name="upsellItemDetailsModal"
    :display-header-title="false"
  >
    <upsell-item-details
      :upsell-menu-item="data.upsellMenuItem"
      @update-upsell-item-data="data.updateUpsellItemData"
    />
  </modal>
</template>


<script>
  import UpsellItemDetails from './upsell-item-details/index.vue';


  export default {
    name: 'UpsellItemDetailsModal',

    components: {
      UpsellItemDetails
    }
  };
</script>
